import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsNotFoundRoute: InvariantJiraRoute = {
	exact: false,
	name: 'customer-service-not-found',
	path: '/jira/helpcenter/:any',
};
